import { render, staticRenderFns } from "./PrincipalForm.vue?vue&type=template&id=415d5d46&"
import script from "./PrincipalForm.vue?vue&type=script&lang=js&"
export * from "./PrincipalForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports